import { useState } from "react";
import type { FormEvent } from "react";
import { changePassword } from "../lib/api";

type Props = {
  onChanged: () => void | Promise<void>;
};

export default function ChangePasswordScreen({ onChanged }: Props) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);

    if (!currentPassword || !newPassword) {
      setError("現在のパスワードと新しいパスワードを入力してください");
      return;
    }
    if (newPassword.length < 8) {
      setError("新しいパスワードは8文字以上にしてください");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("新しいパスワード(確認)が一致しません");
      return;
    }

    setSubmitting(true);
    const res = await changePassword(currentPassword, newPassword);
    setSubmitting(false);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    await onChanged();
  }

  return (
    <div className="login-screen">
      <div className="login-card">
        <h1 className="login-title">パスワード変更が必要です</h1>
        <p className="login-subtitle">
          初回ログイン、またはリセットされたパスワードのままです。新しいパスワードを設定してください。
          (このパスワードはmanual-portalのログインにも使われます)
        </p>

        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-field">
            <span>現在のパスワード</span>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              autoComplete="current-password"
            />
          </label>
          <label className="login-field">
            <span>新しいパスワード(8文字以上)</span>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
            />
          </label>
          <label className="login-field">
            <span>新しいパスワード(確認)</span>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
            />
          </label>
          {error && <p className="login-error">{error}</p>}
          <button type="submit" className="btn btn--primary" disabled={submitting}>
            {submitting ? "変更中..." : "パスワードを変更する"}
          </button>
        </form>
      </div>
    </div>
  );
}
